'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Avatar = require('../../01.atoms/Avatar/Avatar.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-profile',
    cnLoggedIn = "".concat(CLASSNAME, "--logged-in"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnSubline = "".concat(CLASSNAME, "__subline"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnAvatar = "".concat(CLASSNAME, "__avatar"),
    cnButtons = "".concat(CLASSNAME, "__buttons"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnButtonEdit = "".concat(cnButton, " ").concat(cnButton, "--edit"),
    cnContent = "".concat(CLASSNAME, "__content");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function TeaserProfile(_ref) {
  var className = _ref.className,
      content = _ref.content,
      headlineLevel = _ref.headlineLevel,
      headline = _ref.headline,
      i18n = _ref.i18n,
      linkLogin = _ref.linkLogin,
      linkProfile = _ref.linkProfile,
      linkRegister = _ref.linkRegister,
      onClickLogin = _ref.onClickLogin,
      onClickProfile = _ref.onClickProfile,
      onClickRegister = _ref.onClickRegister,
      profile = _ref.profile,
      style = _ref.style;
  var classes = [className, CLASSNAME, "".concat(CLASSNAME, "--").concat(style)],
      loggedIn = !!profile;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(classes, _rollupPluginBabelHelpers.defineProperty({}, cnLoggedIn, loggedIn))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnAvatar, cnCol)
  }, loggedIn && /*#__PURE__*/React__default.createElement("h1", {
    className: cnTitle
  }, i18n.profile), /*#__PURE__*/React__default.createElement(Avatar, profile)), /*#__PURE__*/React__default.createElement("div", {
    className: cnCol
  }, /*#__PURE__*/React__default.createElement(Headline, {
    className: cnSubline,
    level: headlineLevel
  }, profile ? "".concat(profile.firstName || '', " ").concat(profile.lastName || '') : headline), content.map(function (c, i) {
    return /*#__PURE__*/React__default.createElement("p", {
      key: i,
      className: cnContent
    }, c);
  }), loggedIn ? null : /*#__PURE__*/React__default.createElement("div", {
    className: cnButtons
  }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: i18n.login,
    iconSize: "xxs",
    className: cnButton,
    link: linkLogin,
    onClick: onClickLogin
  }), /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: i18n.register,
    type: "secondary",
    iconSize: "xxs",
    className: cnButton,
    link: linkRegister,
    onClick: onClickRegister
  })))), loggedIn && /*#__PURE__*/React__default.createElement("div", {
    onClick: onClickProfile
  }, /*#__PURE__*/React__default.createElement(Link, {
    link: linkProfile,
    className: cnButtonEdit
  }, i18n.editProfile)));
}
TeaserProfile.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Content */
  content: PropTypes.arrayOf(PropTypes.string),

  /** Level of headline e.g. 1 for h1 */
  headlineLevel: PropTypes.number,

  /** Title */
  headline: PropTypes.string,

  /** Translation object */
  i18n: PropTypes.shape({
    profile: PropTypes.string.isRequired,
    login: PropTypes.string.isRequired,
    register: PropTypes.string.isRequired,
    editProfile: PropTypes.string.isRequired
  }).isRequired,

  /** URL to link to when login clicked */
  linkLogin: PropTypes.string,

  /** URL to link to when profile clicked */
  linkProfile: PropTypes.string,

  /** URL to link to when register clicked */
  linkRegister: PropTypes.string,

  /** Callback function */
  onClickLogin: PropTypes.func,

  /** Callback function */
  onClickProfile: PropTypes.func,

  /** Callback function */
  onClickRegister: PropTypes.func,

  /** Profile object */
  profile: PropTypes.shape(),

  /** Style options */
  style: PropTypes.oneOf(['light', 'dark'])
};
TeaserProfile.defaultProps = {
  content: [],
  headlineLevel: 2,
  i18n: {},
  onClickLogin: function onClickLogin() {
    return void 0;
  },
  onClickProfile: function onClickProfile() {
    return void 0;
  },
  onClickRegister: function onClickRegister() {
    return void 0;
  },
  style: 'light'
};

module.exports = TeaserProfile;
